module.exports = "#gameContainer{\n    background: red;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unity/unity.component.css
// module id = ./src/app/unity/unity.component.css
// module chunks = main